import React, { createContext, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import axios from 'axios'

import useNetwork from "../hooks/useNetwork";

// future:
// maybe show a yellow dot if they have bad connectivity?
// fix the since not showing on first load

// cache api: future expiratiion dates:
// https://gomakethings.com/how-to-set-an-expiration-date-for-items-in-a-service-worker-cache/

// cancel fetch:
// https://davidwalsh.name/cancel-fetch

// progress indicator (if you have zip issues):
// https://stackoverflow.com/questions/47285198/fetch-api-download-progress-indicator


// LKLKLK:
// on first load, check to see if there are any locally saved indexeddb things
// then will need to move the cache check to... it's own component

// lklklk future:
// consider moving the configs to eams-admin/system db so we can push updates via db


export const SiteContext  = createContext({});

export const SiteProvider = ({ hostname, children }) => {
  const networkState = useNetwork();
  const { online } = networkState;

  const [config, setConfig] = useState({ title: '' });
  const [siteSchemas, setSiteSchemas] = useState([]);
  const [syncing, setSyncing] = useState(0);

  useEffect(() => {
    console.log(hostname);

    (async () => {
      try {
        const res = await axios.request({method: "GET", url: `/system/schemas`});
        if(!res.status === 200) alert('Error.'); // lklklk
        setSiteSchemas(res.data);
      } catch (error) {
        console.log(error);
        alert('Error.'); // lklklk
      }
    })();

    // lklklk for later:
    // https://stackoverflow.com/questions/46835825/conditional-css-in-create-react-app

    let config = { title: '' };

    require(`../styles/_products/wayfinder.scss`);
    // require(`../styles/_products/wayfindit.scss`);
    // require(`../styles/_products/sfo.scss`);
    // require(`../styles/_products/icp.scss`);

    if(hostname.includes('wayfindit') || hostname==='admin.mstdsqr.com') {
      config = {
        product: 'mapping',
        title: 'Wayfindit',
        supportEmail: { name: 'Wayfindit Support', email: 'support@wayfindit.com' },
        adminIds: [1],
        // below are default schemaIds, ie for Wayfindit defaults
        schemaIds: {
          'edit-plot': 25
        },
        taskEmails: false
      }
    } else if(hostname==='wgs.flysfo.io') {
      config = {
        product: 'mapping',
        title: 'WGS',
        supportEmail: { name: 'Wayfinding @ SFO', email: 'wayfinding@flysfo.com' },
        adminIds: [2],
        taskEmails: false,
        selfRegister: true
      }
    } else if(hostname==='icp.jblapp.com') {
      config = {
        product: 'mapping',
        title: 'ICP',
        supportEmail: { name: 'ICP Support', email: 'support@junebuglabs.com' },
        adminIds: [1],
        taskEmails: false
      }
    }

    setConfig(config);

    if (typeof navigator.storage.estimate === 'function') {
        navigator.storage.estimate().then((estimate) => {
          let avail = (estimate.usage / estimate.quota * 100).toFixed(2);
          // console.log(estimate.usage);
          // console.log(estimate.quota);
          console.log(`storage: ${avail}%`);
        });
    } else {
      console.log('storage: estimate not available');
    }
  }, [hostname]);

  return (
    <SiteContext.Provider value={{ hostname, config, siteSchemas, syncing, setSyncing }}>
      <Helmet>
        <title>{config.title}</title>
      </Helmet>

      {children}
      { !online && (
        <div className="position-fixed bg-danger" style={{
            bottom:16,
            right:16,
            zIndex:101,
            height:16,
            width:16,
            borderRadius:8
          }}>
        </div>
      )}

      { syncing > 0 && (
        <div className="position-fixed spinner-border spinner-border-sm text-dark" style={{bottom:16,right:16,zIndex:101}} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      )}

      { hostname==='wgs.flysfo.io' && (
        <div className="d-none d-md-block shadow-sm pointer" style={{position:'fixed', bottom:16, right: 16}}>
          {/* <button className="btn btn-secondary">Need Help?</button> */}
          <a href="mailto:wayfinding@flysfo.com" className="btn btn-secondary" tabIndex="-1" role="button" aria-disabled="true">Need help?</a>
        </div>
      )}

    </SiteContext.Provider>
  );
};
